import { render, staticRenderFns } from "./ViewInvoicesView.vue?vue&type=template&id=0a1a6d54&scoped=true"
import script from "./ViewInvoicesView.vue?vue&type=script&lang=js"
export * from "./ViewInvoicesView.vue?vue&type=script&lang=js"
import style0 from "./ViewInvoicesView.vue?vue&type=style&index=0&id=0a1a6d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a6d54",
  null
  
)

export default component.exports